import { useEffect, useLayoutEffect } from 'react';

/**
 * `useLayoutEffect` on the client, `useEffect` on the server.
 *
 * React skips layout effects during SSR and warns when a component that uses one renders there, so the plain hook
 * cannot be used in a component the server renders. Swapping it out keeps the client's before-paint timing without
 * the warning.
 */
export const useIsomorphicLayoutEffect =
    typeof window === 'undefined' ? useEffect : useLayoutEffect;
